<template>
  <div class="rotation-box">
    <!--底座-->
    <div class="rotation3D-baseMap"></div>
    <!--旋转3D-->
    <div id="rotation3D" class="rotation3D">
      <div class="center">新智造</div>
      <div class="itemList">
        <div class="rotation3D__item" :class="item.type" v-for="(item,index) in itemList" :key="index" @click="hanle(item.url,item.isnt,item.Accessp)">
          <div class="scale">
            <div class="baseImg"></div>
            <div class="cont">
              <i class="iconfont" :class="item.icon"></i>
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="lineList">
        <div class="rotation3D__line" v-for="(item,index) in itemList" :class="item.type" :key="index">
          <div v-if="item.type=='blue'" class="pos">
            <svg width="10" height="400">
              <path id="path1" d="M0 400, 0 0" stroke-dasharray="5,10"/>
            </svg>
            <div class="dot dot1 el-icon-caret-right"></div>
          </div>
          <div v-if="item.type=='yellow'" class="pos">
            <svg width="10" height="400">
              <path id="path2" d="M0 400, 0 0" stroke-dasharray="5,10"/>
            </svg>
            <div class="dot dot2"><i class="el-icon-close"></i></div>
          </div>
          <div v-if="item.type=='green'" class="pos" style="left: -16px;">
            <svg width="50" height="400">
              <path id="path3" d="M20 400 S 0 200, 20 0" stroke-dasharray="5,10"/>
              <path id="path4" d="M20 400 S 40 200, 20 0" stroke-dasharray="5,10"/>
            </svg>
            <div class="dot dot3 el-icon-caret-right"></div>
            <div class="dot dot4 el-icon-caret-right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/views/homeManage/module/rotation3D/rotation3D.js'
import myStorage from "../../../bll/utils";
export default {
  name: "center-content",
  data () {
    return {
      itemList: [
        // { name:'智能搜索', type:'blue', icon:'icon-renyuanguanli', },
        // { name:'行业应用', type:'green', icon:'icon-GPS', },
        // { name:'权威资讯', type:'yellow', icon:'icon-a-lujishigong2x', },
        // { name:'产业知识库', type:'blue', icon:'icon-shujufuwuzhongxin', },
        // { name:'产业生态', type:'blue', icon:'icon-liangchang', },
        // { name:'新智造', type:'blue', icon:'icon-tanpuyashifuwu', },
        // { name:'产业赋能', type:'blue', icon:'icon-lumianshigong', },
        // { name:'政府服务', type:'blue', icon:'icon-shiyanjiance', },
        // { name:'数字孪生', type:'blue', icon:'icon-keji', url:'https://elec.fanruan.com/industry/',isnt:true},
        { name:'应急救援指挥', type:'blue', icon:'icon-yingjijiuyuanduiwu',url:'/newsmart?id=5',isnt:true , Accessp:false},
        { name:'智能工厂', type:'green', icon:'icon-channeng',url:'/textile',isnt:true, Accessp:true},
        // { name:'华瑞ERP', type:'blue', icon:'icon-icon',url:'/infotom?id=2',isnt:true  },
        // { name:'公共管理', type:'blue', icon:'icon-gonggongguanli',url:'/newsmart?id=6',isnt:true , Accessp:false },
        { name:'数智印染', type:'green', icon:'icon-buliao', url:'/Pdworkshop',isnt:true, Accessp:true},
        // { name:'工业APP', type:'blue', icon:'icon-GPS', url:'/industrial',isnt:true},
        { name:'棉纺工业互联', type:'blue', icon:'icon-keji', url:'http://dev.hrerp.com.cn/login?redirect=%2F&account=zxy&password=1234Qwer',isnt:true , Accessp:false},
        // { name:'生产管控', type:'green', icon:'icon-shengchan',url:'/newsmart?id=2',isnt:true  , Accessp:false},
        { name:'能效管理', type:'green', icon:'icon-gaiicon-1',url:'/Pkworkshop',isnt:true  , Accessp:true},
        // { name:'工业生产能效', type:'green', icon:'icon-nengyuanguanli',url:'/newsmartdetail?id=61',isnt:false },
        // { name:'丝筒标签', type:'blue', icon:'icon-tanpuyashifuwu',url:'/infotom?id=4',isnt:true  },
        { name:'设备管理', type:'green', icon:'icon-shebeiguanli1',url:'/spinning',isnt:true , Accessp:false},
        // { name:'设备管理', type:'green', icon:'icon-shebeiguanli1',url:'/newsmart?id=3',isnt:true , Accessp:false},
        { name:'安全环保', type:'green', icon:'icon-anquanhuanbao',url:'/newsmart?id=4',isnt:true  , Accessp:false},
        { name:'供应链经营', type:'blue', icon:'icon-gongyinglian',url:'/newsmart?id=1',isnt:true , Accessp:false},
        { name:'仓储云眸', type:'green', icon:'icon-jiankongshexiangtou-xianxing',url:'/storagevideo',isnt:false, Accessp:true},
      ],
    }
  },
  mounted: function () {
    new Rotation3D({
      id: '#rotation3D',
      farScale: 0.6,
      // farScale: 1,
      xRadius: 0,  //x半径压缩
      yRadius: 220,  //y半径压缩
      // yRadius: 0,  //y半径压缩
      // autoPlay:true,
      // autoPlayDelay:6000,
    })

  },
  methods: {
    hanle(url,n,p) {
      console.log(url,n,p)
      let info=myStorage.getItem('localStorage','userinfo')
      if(p){
        if(info){
          // const infoname=info.zhnc
          // if((process.env.ACCESSP).indexOf(infoname)>=0){
          this.gotoOutsidechain(url, n)
          // }else {
          //   this.$message({
          //     type: 'warning',
          //     duration:5000,
          //     message: '该功能需要访问权限才能进入，请联系管理员！'
          //   })
          // }
        }else {
          let $this=this
          this.$alert('您还未登录或登录已失效，不可以访问其他功能！', '系统提示', {
            confirmButtonText: '去登录',
            type: 'warning',
            center: true,
            callback: action => {
              localStorage.setItem('gotourl',url)
              $this.$router.push('/login')
            }
          })
        }
      }else {
        this.gotoOutsidechain(url,n)
      }
    },
    gotoOutsidechain(url,n){
      if(n){
        if(url.indexOf('http')<0){
          let routeData = this.$router.resolve({path: url})
          console.log(routeData)
          window.open(routeData.location.hash || routeData.href, "_blank")
        }else {
          window.open(url, "_blank")
        }
      }else {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style scoped>
.rotation-box {
  transform: scale(0.90);
  display: flex;
  transform-origin: 0 0;
  position: absolute;
  flex-direction: column;
  transition: 0.2s;
  left: 5.6%;
  top: 16px;
}


@font-face{
  font-family:element-icons;
  src:url('./rotation3D/element-icons.woff') format("woff"),
  url('./rotation3D/element-icons.ttf') format("truetype");
  font-weight:400;
  font-style:normal
}

[class*=" el-icon-"],[class^=el-icon-]{
  font-family:element-icons!important;
  speak:none;
  font-style:normal;
  font-weight:400;
  font-variant:normal;
  text-transform:none;
  line-height:1;
  vertical-align:baseline;
  display:inline-block;
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale
}

.el-icon-caret-right:before{content:"\e60e"}

.rotation3D-baseMap{
  position: absolute;
  left: -60px;
  right: 0;
  top: 30px;
  margin: auto;
  width: 940px;
  height: 616px;
  background: url("./rotation3D/img/baseMap.png") no-repeat center 100px;
  text-transform:uppercase;
}
.rotation3D-baseMap::before{
  position: absolute; left: -12px; right: 0; top: 100px; margin: auto; z-index: 99;
  width: 342px; height: 318px; display: block; content: '';
  background: url("./rotation3D/img/ai1.gif") no-repeat center/72%;
  animation: 10s bounceUpDown infinite;
  /*filter:grayscale(80%);*/
  filter:contrast(98%) brightness(81%) hue-rotate(348deg) saturate(100%); /*对比度 亮度 色相旋转 饱和度*/
}


/*
  椭圆会使内部失真    transform: rotateX(50deg);
*/
.rotation3D{
  position: relative; width: 800px; height: 800px; cursor: move; user-select: none;
  margin: 0 auto; margin-top: -100px;
}
.rotation3D .center{
  position: absolute;
  left: 50.6%;
  top: 56.5%;
  transform: translate(-50%, -50%);
  font-size: 30px;
  font-family: "fzskjt";
  color: #D7E7FF;
  letter-spacing:6px;
  text-align: center;
  text-shadow: 2px 3px 3px rgba(0,0,0,.4);
  box-reflect: below 1px linear-gradient(transparent,transparent 50%,rgba(255,255,255,.3));
  -webkit-box-reflect: below 1px linear-gradient(transparent,transparent 50%,rgba(255,255,255,.3));
  z-index: 88;
}

.rotation3D .itemList{ position: absolute; width: 100%; height: 100%; z-index: 20; }
.rotation3D .lineList{
  position: absolute; width: 100%; height: 100%; z-index: 10;
  transform-style: preserve-3d;
}

/*---------------------------点样式---------------------------*/
.rotation3D__item{
  position: absolute; display: block; cursor: pointer; width: 161px; height: 188px;
  text-align: center; line-height: 30px; font-size: 18px; color: white;
  /*background: #2292ef; border-radius: 4px;*/
}
.rotation3D__item .scale{ position: absolute; top: 0; width: 100%; height: 100%; }
.rotation3D__item .cont{ position: relative; z-index: 2; }
.rotation3D__item .cont .iconfont { font-size: 32px; margin-top: 30px; margin-bottom: 60px; display: block; }
.rotation3D__item .cont p{ color: #fff; }

.rotation3D__item.blue{ color: #01e9fc; }
.rotation3D__item.green{ color: #02e943; }
.rotation3D__item.yellow{ color: #ffd200; }

/*底座*/
.rotation3D__item .baseImg{ position: absolute; width: 100%; height: 100%; z-index: 1; }
.rotation3D__item.blue .baseImg{ background: url("./rotation3D/img/blue.png"); }
.rotation3D__item.green .baseImg{ background: url("./rotation3D/img/green.png"); }
.rotation3D__item.yellow .baseImg{ background: url("./rotation3D/img/yellow.png"); }

/*---------------------------
    线样式
    线高为总高的一般
---------------------------*/
.rotation3D__line{
  position: absolute; left: 50%; top: 50%;
  display: block; width: 2px; height: 50%;
  padding-top: 60px; color: #fff; font-size: 50px;
  /*background: #fff;*/
  /*原点设置在中间*/
  transform-origin: 50% 0;
  transform-style: preserve-3d;
}
.rotation3D__line .pos{ position: absolute; top: 0; }
.rotation3D__line svg { position: absolute; top: 0; }
.rotation3D__line svg path {
  stroke: #fff; fill: none;
  stroke-width: 3;
  animation: path-animation 100s linear 0s infinite normal;
}
@keyframes path-animation {
  0% { stroke-dashoffset:500; }
  100% { stroke-dashoffset:0; }
}
.rotation3D__line .dot {
  position: absolute; top: 0; left: 0; text-align: center;
  /*width: 35px; height: 35px; font-size: 35px; */
  width: 24px; height: 24px; font-size: 24px;
}
.rotation3D__line .dot1,.rotation3D__line .dot3,.rotation3D__line .dot4{
  animation: svg-path-animation 6s ease-in-out 0s infinite normal;
}
.rotation3D__line .dot1{
  offset-path: path("M0 400, 0 0"); offset-distance: 0%;
}
.rotation3D__line .dot2{
  offset-path: path("M0 200, 0 0"); offset-distance: 0%;
  background: #ffd200; border-radius: 100%;
  font-size: 22px; color: #000;
}
.rotation3D__line .dot3{
  offset-path: path("M20 400 S 0 200, 20 0"); offset-distance: 0%;
}
.rotation3D__line .dot4{
  offset-path: path("M20 0 S 40 200, 20 400"); offset-distance: 0%;
}
@keyframes svg-path-animation {
  from {offset-distance: 0%;}
  to {offset-distance: 100%;}
}

/*颜色*/
.rotation3D__line.blue { color: #07b2f9; }
.rotation3D__line.green { color: #00ff5b; }
.rotation3D__line.yellow { color: #ffd500; }

.rotation3D__line.blue svg path { stroke: #07b2f9; }
.rotation3D__line.green svg path { stroke: #00ff5b; }
.rotation3D__line.yellow svg path { stroke: #ffd500; }
</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/center-content.vue